/** @file viewportCanvas: the Pose viewport's canvas element, or null while the Pose screen is not shown. */

/** The canvas inside `[data-viewport="edit"]` (the Art turntable viewport is not it). */
export function viewportCanvas(): HTMLCanvasElement | null {
  return document.querySelector<HTMLCanvasElement>('[data-viewport="edit"] canvas');
}
